
import { mapGetters } from 'vuex';

export default {
  props: {
    html: {
      type: String,
      default: '',
    },
    isUser: {
      type: Boolean,
      default: false,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters('chatbotStore', ['ampConfig']),

    className() {
      return ['node-message', { 'is-user': this.isUser }];
    },

    avatar() {
      return this.ampConfig?.avatar;
    },

    avatarChar() {
      return this.ampConfig?.avatar ? '' : (this.ampConfig?.name || '').substr(0, 1).toUpperCase();
    },
  },
};
